class IcsQuestionnaireController {
    constructor(toastr, ICSServiceApi, UtpSimServiceApi, moment, SettingsExService) {
        this.$onInit = () => {
            this.boolValues = ['Yes', 'No'];
            this.state = {
                selectedTesterId: 0,
                selectedSimId: 0,
                selectedICSIndex: 0,
                IsICSDataAvailable: true,
                icsData: [],
                readOnly: false
            };
            this.allButtonActive = true;
            this.state.selectedTesterId = this.userId;
            this.state.selectedSimId = this.simId;
            this.state.readOnly = this.readOnly;
            this.SettingsExService.getCachedSettings().then((settings) => {
                this.dateTimeFormat = settings.DateTimeFormat;
            });
        };
        this.loadData = () => {
            this.ICSServiceApi.getICSForSimulator(this.userId, this.simId).then((response) => {
                let ICSData = response.data;
                if (ICSData && ICSData.length > 0) {
                    this.originalIcsData = ICSData;
                    // First node will be the parent "ICS" node so just ignore it
                    this.state.icsData = this.buildTreeData(ICSData[0].children);
                    this.icsgridOptions.api.setRowData(this.state.icsData);
                }
                else {
                    this.state.IsICSDataAvailable = false;
                }
            });
        };
        this.buildTreeData = (data, parentSegment) => {
            const returnData = [];
            if (!data || data.length === 0)
                return returnData;
            for (const row of data) {
                const type = row.ICSType;
                switch (type) {
                    case 'SEGMENT':
                        returnData.push(Object.assign({ path: [row.SegmentText] }, row));
                        returnData.push(...this.buildTreeData(row.children, row.SegmentText));
                        break;
                    case 'QUESTION':
                        const path = [row.QuestionText];
                        if (parentSegment)
                            path.unshift(parentSegment);
                        returnData.push(Object.assign({ path: path }, row));
                        break;
                }
            }
            return returnData;
        };
        this.save = () => {
            // We removed the root ICS node on load, put it back in before sending data back up
            const fullIcsData = this.originalIcsData;
            fullIcsData[0].children = this.state.icsData;
            this.ICSServiceApi.updateICS(fullIcsData, this.state.selectedTesterId, this.state.selectedSimId)
                .then((response) => {
                if (response.data) {
                    this.toastr.info('ICS data saved successfully');
                    this.loadData();
                }
                else {
                    this.toastr.error('Data not updated. Contact support.');
                }
            });
        };
        this.setAllValues = (newValue) => {
            this.icsgridOptions.api.forEachNode((row, index) => {
                let question = row.data;
                if (question.IsAnswerable && _.includes(this.boolValues, question.AnswerText)) {
                    question.AnswerText = newValue;
                }
                row.setData(question);
            });
        };
        this.exportToCSV = () => {
            const params = {
                allColumns: false,
                fileName: `${this.moment(new Date()).utc().format(this.dateTimeFormat)}-${this.userName}-${this.simulatorName}-ics.csv`,
            };
            this.icsgridOptions.api.exportDataAsCsv(params);
        };
        this.icsgridOptions = {
            defaultColDef: {
                resizable: true,
                autoHeight: true,
                minWidth: 100,
                cellClass: 'cell-wordwrap'
            },
            autoGroupColumnDef: {
                headerName: 'Question',
                autoHeight: true,
                wrapText: true,
                flex: 3,
                cellRendererParams: {
                    suppressCount: true
                },
                filter: 'text'
            },
            columnDefs: [{
                    headerName: 'Answer',
                    field: 'AnswerText',
                    singleClickEdit: true,
                    cellRenderer: (params) => {
                        if (params.data.IsAnswerable && !this.readOnly) {
                            const icon = params.data.DisplayOptions ? 'fa-caret-down' : 'fa-pencil';
                            return `<span class="space-right fa fa-md ${icon}"></span>${params.value}`;
                        }
                        return params.value;
                    },
                    editable: (params) => {
                        return params.data.IsAnswerable && !this.readOnly;
                    },
                    cellEditorSelector: (params) => {
                        if (params.data.DisplayOptions) {
                            return {
                                component: 'agRichSelectCellEditor',
                                params: {
                                    values: params.data.DisplayOptions,
                                }
                            };
                        }
                        else {
                            return {
                                component: 'agTextCellEditor'
                            };
                        }
                    },
                    flex: 1,
                    filter: true
                }],
            onGridReady: () => {
                this.loadData();
            },
            onRowDataChanged: (event) => {
                event.api.expandAll();
            },
            suppressMovableColumns: true, // Added because of ag-grid bug see https://github.com/ceolter/ag-grid/issues/965#issuecomment-225857509
            angularCompileRows: true,
            treeData: true,
            getDataPath: (row) => row.path
        };
        this.toastr = toastr;
        this.ICSServiceApi = ICSServiceApi;
        this.UtpSimServiceApi = UtpSimServiceApi;
        this.moment = moment;
        this.SettingsExService = SettingsExService;
    }
}
angular.module('app').component('icsQuestionnaire', {
    bindings: {
        userId: '<',
        simId: '<',
        testSuiteId: '<',
        readOnly: '<',
        userName: '<',
        simulatorName: '<'
    },
    templateUrl: 'scripts/app/partials/ICS/ics-questionnaire.tpl.html',
    controllerAs: 'vm',
    controller: IcsQuestionnaireController
});
